const requestDocumentsPageStyle = {
  box: {
    padding: "0.25rem 1rem 1rem",
    marginBottom: "1rem",
  },
};

export default requestDocumentsPageStyle;
